// Helper function to get a value in a nested object and return undefined if
// we couldn't reach the end of the nested object.
export function getNested(obj, ...args) {
  return args.reduce((obj, level) => obj && obj[level], obj);
}
